/** Helpers de Web Push — Controle de Equipamentos */

export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registerPushServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  await navigator.serviceWorker.ready;
  return reg;
}

export async function subscribeWebPush(apiUrl) {
  if (!('Notification' in window) || !('PushManager' in window)) {
    return { ok: false, reason: 'unsupported' };
  }
  if (Notification.permission !== 'granted') {
    return { ok: false, reason: Notification.permission };
  }

  const { data } = await axiosGet(`${apiUrl}/push/vapid-public-key`);
  if (!data?.publicKey || !data?.configured) {
    return { ok: false, reason: 'vapid_not_configured' };
  }

  const reg = await registerPushServiceWorker();
  if (!reg) return { ok: false, reason: 'no_sw' };

  // Garante inscrição com a chave VAPID atual
  let sub = await reg.pushManager.getSubscription();
  if (sub) {
    try {
      await sub.unsubscribe();
    } catch (_) {
      /* ignore */
    }
  }
  sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.publicKey),
  });

  const saved = await axiosPost(`${apiUrl}/push/subscribe`, {
    subscription: sub.toJSON(),
    userAgent: navigator.userAgent,
  });

  return {
    ok: true,
    subscriptions: saved?.data?.subscriptions ?? data.subscriptions,
  };
}

export async function sendTestPush(apiUrl) {
  const res = await fetch(`${apiUrl}/push/test`, { method: 'POST' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.reason || data.error || 'Falha no teste de push');
  }
  return data;
}

async function axiosGet(url) {
  const res = await fetch(url);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Erro ao buscar chave push');
  return { data };
}

async function axiosPost(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Erro ao salvar inscrição push');
  return { data };
}
